import { PortfolioStatusState } from '../../../types/portfolios/portfolioData';

export const PORTFOLIO_FILTER_ALL = 'ALL';

export const PortfolioFilterDropdown = [
  { label: 'All', value: PORTFOLIO_FILTER_ALL },
  { label: 'Active', value: PortfolioStatusState.ACTIVE },
  { label: 'Closed', value: PortfolioStatusState.CLOSED },
  { label: 'Initial', value: PortfolioStatusState.INITIAL },
  { label: 'In closing', value: PortfolioStatusState.IN_CLOSING },
] as const;

export type PortfolioFilterOption = (typeof PortfolioFilterDropdown)[number];

export type PortfolioFilterValue = PortfolioFilterOption['value'];
